<template>
  <div class="">

 <v-container class="play-page hero" fluid>
  <!-- <top-nav-bar :user="user"/> -->

  <v-btn block tile color="red darken-4" class="mt-5 mb-2 d-flex align-start flex-column" @click="goTo('/')"><v-icon class="mr-1" size="17">mdi-arrow-left</v-icon> BACK</v-btn>

    <v-row class="pl-2 pr-2">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="main-play-page pl-4 pr-4" outlined style="background-color:rgb(16,16,16);">


<p class="mt-5">RULES OF PLAY:</p>
      <ol class="body-1">
        <li class="mb-3">
          In addition to these Terms and Conditions, certain Rules of Play shall apply to you during your engagement in this website.
        </li>
        <li class="mb-3">
          You hereby agree to be bound by the aforementioned Rules of Play as if they were specifically incorporated into these Terms and Conditions.
        </li>
        <li class="mb-3">
          <strong>Meron</strong> and <strong>Wala</strong> bets are subject to a "plasada of 5%". Draw pays 8:1.
        </li>
        <li class="mb-3">
          Betting can only be done through the Game/Betting Console. Betting done through any other means besides the Game/Betting Console is VOID.
        </li>
        <li class="mb-3">
          We reserve the right to exclude players from participating in the betting without prior notice and/or providing reasons for the exclusion.
        </li>
        <li class="mb-3">
          In the event of a "DRAW" result, all bet points placed on Meron and Wala are returned to the player's points and no plasada of 5% to be deducted. If you have placed a bet on “DRAW” you will be paid x 8 (bet points will be multiplied by 7 winnings will be x7 include the bet points) e.g bet points 100 multiplied by 7 = 700 include bet of 100 total payouts 800 these are points no plasada to be deducted if we have a Draw winning result.
        </li>
        <li class="mb-3">
          In the event of a "<strong>CANCEL</strong>" fight all bets placed by the player on Meron, Wala and Draw will return to the player’s current points without any deductions.
        </li>
        <li class="mb-3">
          Fights shall be canceled under the following circumstances:
          <ul  class="mt-3 body-2">
            <li class="mb-2">Wrong entry names of one or both of the protagonists displayed shall be canceled.</li>
            <li class="mb-2">Incorrect positioning of opposing roosters. (Note Red Tape should always be on the MERON/Red side. White tape should always be on the WALA/Blue side.</li>
            <li class="mb-2">Knife tape colors are the same/or no leg tape present fight should be canceled. (Note “Meron” should always be red tape. “Wala” should always be White tape.)</li>
            <li class="mb-2">One or both roosters is/are unfit to fight. E.G. If a rooster is limping (namimilay), manifests signs of hesitation (nangangayaw) and/or is accidentally wounded prior to its release (Nasugatan ang manok) fight will be canceled.</li>
            <li class="mb-2">Fights with payout odds equal or below 107 for MERON and WALA fight will be canceled.</li>
            <li class="mb-2">If the knife of a rooster is damaged or blunt fight will be canceled.</li>
            <li class="mb-2">Show-Up fights, which is a situation when the Game Cock is already scheduled, but it is not ready, e.g. with no knives yet, showing signs of weakness, dizziness, shivering or shaking, and manifest signs of unwillingness to fight.</li>
            <li class="mb-2">Sudden power outage and/or technical difficulties related to broadcast internet connection, and the like and we don’t have a record for the said fight it will be canceled due to technical issues</li>
            <li class="mb-2">If the referee (SENTENCIADOR) sees signs that the rooster is showing weakness, dizziness, shivering or shaking, and manifest signs of unwillingness to fight, the referee (SENTENCIADOR) can cancel the fight prior to release.</li>
          </ul>
        </li>
        <li class="mb-3">
          The DECLARED WINNER by the referee (SENTENCIADOR) at the end of a match is FINAL.
        </li>

        <li class="mb-3">
         In the event of a <strong>Reset Betting</strong> all bets that’s been placed will be returned to the player's current points.
        </li>

        <li class="mb-3">
          In the event of <strong>Re declare</strong> wrong declaration of Winner will be corrected by this process.
        </li>

        <li class="mb-3">
         In the event of <strong>Reverse Betting</strong> it will return to the previous fight.
        </li>

        <li class="mb-3">
          The system computes the payouts AUTOMATICALLY after the RESULT has been DECLARED.
        </li>

        <li class="mb-3">
         Total Bets from Meron and Wala will also display to Betting Console.
        </li>

        <li class="mb-3">
         Current Points that the player sees have an equivalent of 1pt to 1peso.
        </li>

        <li class="mb-3">
         After placing Bets in Meron, Wala or Draw, and after the betting is closed, the expected winnings will be displayed base on the odds/payout.
        </li>

        <li class="mb-3">
         The betting period has a minimum of 2 to 3 minutes.
        </li>

        <li class="mb-3">How to compute Payout for <span style="color:red">Meron</span> or <span style="color:#0070c0">Wala</span> per fight.
        e.g. Value is all point
          <ul class="mt-3 body-2">
            <li class="mb-2">Total <span style="color:red">Meron</span> Bets = 150</li>
            <li class="mb-2">Total <span style="color:#0070c0">Wala</span> Bets = 150</li>
            <li class="mb-2">Plasada = 5% rake deducted from the total bets of <span style="color:red">Meron</span> or <span style="color:#0070c0">Wala</span> (e.g. computation on how to get 5% rake/plasada)</li>
            <ul>
              <li><span style="color:red">Meron</span> 150x.05 = 7.5</li>
              <li><span style="color:#0070c0">Wala</span>  100x.05 = 5</li>
              <li>Total Bet Accumulation 250 x.05 = 12.5</li>
            </ul>
            <li class="mb-3">
             Total Bets = Total <span style="color:red">Meron</span> bets + Total <span style="color:#0070c0">Wala</span> bets = 250
            </li>
            <li class="mb-3">
             Overall total minus 5% rake or Plasada = Sum of total bets of Meron and Wala, less 5% rake.
            </li>

            <li class="mb-3">
              <span style="color:red">Meron</span> Odds = Overall total   minus rake divided by <span style="color:red">Meron</span> bets. = 1.5833
              <ul>
                <li>(e.g. (250 – 12.5 = 237.5)/ 150 = 1.5833)</li>
              </ul>
            </li>
            <li class="mb-3">
              <span style="color:#0070c0">Wala</span> Odds = Overall total minus rake divided by  <span style="color:#0070c0">Wala</span> bets. = 2.3750
              <ul>
                <li>(e.g. (250 – 12.5 = 237.5)/ 100 = 2.3750)</li>
              </ul>
            </li>

            <li class="mb-3">
              <span style="color:red">Meron</span> Payout by One Hundred points = <span style="color:red">Meron</span> odds multiplied by 100.
              <ul>
                <li>(e.g. = 1.5833 x 100 = 158.33)</li>
              </ul>
            </li>

            <li class="mb-3">
              <span style="color:#0070c0">Wala</span> Payout by One Hundred points =  <span style="color:#0070c0">Wala</span> odds multiplied by 100
              <ul>
                <li>(e.g. = 2.3750 x 100 = 237.5)</li>
              </ul>
            </li>

          </ul>
        </li>

        <li class="mb-3">
          Expected/ Potential Winnings will not include the decimal numbers but it will add into current wallet if the side you bet wins.
        </li>

        <li class="mb-3">
          No cancellation of bets after bet is posted. (Note there is always a confirmation every time player posts their bets.)
        </li>

        <li class="mb-3">
          Displaying of Odds/Payout on MERON and WALA will always display zero if no one bets on either side.
        </li>

        <li class="mb-3">
         Minimum points for player to have a view on our event is 100 points. Once player place this point for a bet, he will not be logout he can still view the event. Reason incase the player won he can continue to bet, incase player loss and her points become less than 100 points once he does any transaction like refresh, he will be automatically kick out and won’t be able to view the event.  
        </li>

        <li class="mb-3">
          Minimum and Maximum bet for Meron, Wala and Draw.
          <ul class="mt-3">
            <li class="mb-2">The Minimum bet limit per player on Meron and Wala is 100 points per place of bet.</li>
            <li class="mb-2">The Maximum bet limit per player on Meron and Wala is 1,000,000 points per place of bet.</li>
            <li class="mb-2">The minimum bet limit per player on Draw is 100 points per place of bet. The maximum bet limit per player on Draw is 5,000 points.</li>
            <li class="mb-2">The maximum bet limit from all players per fight on Draw is 100,000 points.</li>
            
          </ul>
        </li>


      </ol>

      </v-col>

    </v-row>

  </v-container>

  </div>
</template>

<script>
import mixin from "./../mixins";
// import TopNavBar from "@/sections/TopNavBar";

export default {
  mixins: [mixin],
  components: {
    // TopNavBar,
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
     goTo(path) {
      this.$router.push({ path: path }).catch(() => {
        this.drawer = false;
      });
    },
    openHelp() {
      window.open(window.SETTINGS.LC_URL, "_system");
    }
  }
};
</script>